import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAddressCollectionData } from '@steelbuy/data-provider';
import { AddressModel, ListingBuyerModel } from '@steelbuy/ts-shared';
import { AddressIdentifier, CardContentMaterialLocation } from '@steelbuy/ui-primitive';
import { useIsVendorFeatureSupported } from '@steelbuy/vendor';
import { CHOOSE_ADDRESS_RELATIVE_PATH } from '../../router/Routes';
import { AddressDetails } from '../address-details/AddressDetails';
import { useCheckoutContext } from '../checkout/CheckoutContext';
import './ListingDetailsDelivery.scss';

export const ListingDetailsDelivery = ({ listingModel }: { listingModel: ListingBuyerModel }) => {
    const navigate = useNavigate();
    const isDeliveryAddressEnabled = useIsVendorFeatureSupported('DYNAMIC_DELIVERY_PRICE');
    const { warehouseAddressCollectionData } = useAddressCollectionData();
    const checkoutContext = useCheckoutContext();
    const warehouseAddresses = warehouseAddressCollectionData.query();
    const defaultWarehouseAddressId =
        (warehouseAddresses.find((address: AddressModel) => address.primary) ?? warehouseAddresses[0])?.id ?? '';

    useEffect(() => {
        if (!checkoutContext.deliveryAddressId) {
            checkoutContext.setDeliveryAddressId(defaultWarehouseAddressId);
        }
    }, [defaultWarehouseAddressId]);

    return (
        <div className="listing-details-delivery">
            {listingModel.country && (
                <CardContentMaterialLocation countryCode={listingModel.country} state={listingModel.state} />
            )}
            {isDeliveryAddressEnabled && (
                <AddressDetails
                    type={AddressIdentifier.DELIVERY_ADDRESS}
                    additionalInfoLabel=""
                    addressId={checkoutContext.deliveryAddressId ?? defaultWarehouseAddressId}
                    onButtonClick={() => navigate(CHOOSE_ADDRESS_RELATIVE_PATH)}
                    hideAddressNotesInput
                    readonly
                />
            )}
        </div>
    );
};
